import { useCallback, useContext, useMemo, useState } from 'react';
import css from './OfficeRank.module.scss';
import UserContext from '../../../../common/utils/getContext';
import Skeleton from '../../../../widgets/plug/Skeleton/Skeleton';
import { getData, navigateV2 } from '../../../../common/utils/router';
import { Img, Tooltip, svgSprite } from '../../../../hybrid/wrappers';
import { rankColors } from '../../../../project/uikit/data-variables/rank-colors';
import classNames from 'classnames';
import T from '../../../../common/components/T';
import ProgressBar from '../../../../widgets/progressBarGT/ProgressBar';
import { skeleton } from './helpers';
import { useWindowDimensions } from '../../../../common/utils/windowDimensions';
import CircleLoader from '../../../../widgets/plug/CircleLoader';

const RenderData = ({ response }) => {
    const { userToken, lang } = useContext(UserContext);
    const [career, setCareer] = useState(response);
    const [cacheReloading, setCacheReloading] = useState(false);
    const rankColor = useMemo(() => {
        if (career) {
            return rankColors[career?.rank?.id] || rankColors[rankColors.length - 1];
        }
        return rankColors[0];
    }, [career]);
    const mobile = useWindowDimensions() < 768;

    const reloadCacheFunc = useCallback(() => {
        if (cacheReloading) return;
        setCacheReloading(true);
        getData('/api/v1/user/career', userToken, lang, false, false, false, false, false, { 'cache-clear': 1 })
            .then((res) => {
                setCareer(res?.data);
                setCacheReloading(false);
            })
            .catch(() => {
                setCacheReloading(false);
            });
    }, [userToken, lang, cacheReloading]);

    return (
        <div className={css.block}>
            <div onClick={reloadCacheFunc} className={classNames('circleButton', css.reloadCareer)}>
                {cacheReloading ? (
                    <CircleLoader />
                ) : (
                    <Tooltip
                        text={
                            <T
                                textName='reload-cache-v1'
                                defaultStr='Данные автоматически обновляются каждые 4ч. Обновить данные принудительно.'
                            />
                        }
                        compStyle={{ tooltipWrapCustom: css.reloadCareerInner }}
                    >
                        {svgSprite('reload')}
                    </Tooltip>
                )}
            </div>
            <Tooltip
                compStyle={{ tooltipWrapCustom: { position: 'static' }, inner: { className: css.button } }}
                text={<T textName='more-details' defaultStr='Подробнее' page='/office' />}
                showModalTooltip={!mobile}
            >
                <div onClick={() => navigateV2('/career')} className={classNames('circleButton', css.buttonInner)}>
                    {svgSprite('arrow-right', { className: css.buttonSvg })}
                </div>
            </Tooltip>
            <div className={css.rank} id={'userRankWrapper'}>
                <ProgressBar
                    config={{
                        width: 280,
                        height: 280,
                        percent: career?.percent,
                        strokeWidth: 20,
                        defaultColor: 'rgba(177, 138, 75, 0.10)',
                        progressColor: [rankColor['gradientColor1'], rankColor['gradientColor2']],
                        id: 'userRank'
                    }}
                />
                <div className={css.info}>
                    <div className={css.rankIcon}>
                        <Img
                            className={classNames(css.rankSvg, `rank${career?.rank?.id || 0}`)}
                            src={`/src/img/ranks/rank${career?.rank?.id || 0}.png`}
                            alt={`rank${career?.rank?.id || 0}`}
                        />
                    </div>
                    <p className={css.label}>
                        <T textName='current_rank' defaultStr='Текущий ранг' page='/office' />
                    </p>
                    <p className={css.rankName}>
                        {career?.rank?.name || <T textName='absent' defaultStr='Отсутствует' page='/office' />}
                    </p>
                </div>
            </div>
            {career?.nextRank?.name ? (
                <p className={css.nextRank}>
                    <span style={{ marginRight: '8px' }} className={css.label}>
                        <T textName='next_rank' defaultStr='Следующий ранг' page='/office' />:
                    </span>
                    <span className={css.rankNameNext}>{career?.nextRank?.name}</span>
                </p>
            ) : null}
        </div>
    );
};

export default function OfficeRank() {
    const { userToken, lang } = useContext(UserContext);

    const handler = useCallback(
        () => getData('/api/v1/user/career', userToken, lang).then((res) => res?.data),
        [userToken, lang]
    );

    return <Skeleton Component={RenderData} handler={handler} wrapperStyles={css.skeleton} pattern={skeleton} lazy={true} />;
}
